import React, { useCallback, useEffect, useState } from 'react';
import './style.css';
import { Row, Col, Radio, Modal, Button, Input } from 'antd';
import LineChart from './lineChartTest';
import useWebSocket, { ReadyState } from 'react-use-websocket';
// import { lowerCase } from "lodash";
// import { axiosLabAPI } from '../axios';

function Boilerplate() {
	const dateTest = new Date();
	const time = dateTest.toLocaleTimeString('en-US').toLocaleLowerCase();
	const dateTime =
		dateTest.getDate() + '/' + dateTest.getMonth() + '/' + dateTest.getFullYear() + ' ' + time;
	const [showModal, setShowModal] = useState(false);

	const [socketUrl, setSocketUrl] = useState(process.env.REACT_APP_WEBSOCKET);
	const [messageHistory, setMessageHistory] = useState([]);

	const { sendMessage, lastMessage, readyState } = useWebSocket(socketUrl);

	const sampleHighlow = {
		FN: 'GETFLAGS',
		FRM: 'RESULTEDIT',
		SRCID: '23',
		VALUE: '51',
		LL: '10',
		UL: '50',
		LV: 'LOW',
		HV: 'HIGH',
		NV: '',
	};

	useEffect(() => {
		if (lastMessage !== null) {
			setMessageHistory(prev => prev.concat(lastMessage));
		}
	}, [lastMessage, setMessageHistory]);

	const connectionStatus = {
		[ReadyState.CONNECTING]: 'Connecting',
		[ReadyState.OPEN]: 'Open',
		[ReadyState.CLOSING]: 'Closing',
		[ReadyState.CLOSED]: 'Closed',
		[ReadyState.UNINSTANTIATED]: 'Uninstantiated',
	}[readyState];

	console.log('dateTime ', dateTime);
	console.log('dateTest =>', dateTest);

	const [dataset, setDataset] = useState({
		minNormData: 33,
		maxNormData: 73.5,
		dataPoints: [
			{
				x: '1/1/2022',
				y: 31,
			},
			{
				x: '2/1/2022',
				y: 45,
			},
			{
				x: '3/1/2022',
				y: 87,
			},
			{
				x: '4/1/2022',
				y: 70,
			},
			{
				x: '5/23/2022',
				y: 54,
			},
			{
				x: '6/1/2022',
				y: 44,
			},
		],
	});

	const onTestChange = elemVal => {
		const { value } = elemVal.target;
		switch (value) {
			case 'rbc':
				setDataset({
					minNormData: 40,
					maxNormData: 78,
					dataPoints: [
						{
							x: '1/1/2021',
							y: 44,
						},
						{
							x: '2/1/2021',
							y: 45,
						},
						{
							x: '3/1/2021',
							y: 87,
						},
						{
							x: '4/1/2021',
							y: 11,
						},
						{
							x: '5/23/2021',
							y: 54,
						},
						{
							x: '6/1/2022',
							y: 44,
						},
					],
				});
				break;
			case 'wbc':
				setDataset({
					minNormData: 34,
					maxNormData: 78,
					dataPoints: [
						{
							x: '1/1/2022',
							y: 33,
						},
						{
							x: '2/1/2022',
							y: 45,
						},
						{
							x: '3/1/2022',
							y: 87,
						},
						{
							x: '4/1/2022',
							y: 70,
						},
						{
							x: '5/23/2022',
							y: 54,
						},
						{
							x: '6/1/2022',
							y: 44,
						},
					],
				});
				break;
			default:
		}
	};

	const handleShowModal = () => {
		setShowModal(true);
	};

	const handleCloseModal = () => {
		setShowModal(false);
	};

	const handleClickSendMessage = useCallback(() => sendMessage(JSON.stringify(sampleHighlow)), []);

	return (
		<div>
			<Row>
				<Col span={24}>
					<Input onKeyPress={handleClickSendMessage}></Input>
				</Col>
				<Col span={24}>
					<span>The WebSocket is currently {connectionStatus}</span>
					{lastMessage ? <span>Last message: {lastMessage.data}</span> : null}
					<ul>
						{messageHistory.map((message, idx) => (
							<text key={idx}>{message ? message.data : null}</text>
						))}
					</ul>
				</Col>
				<Col span={6}>
					<Radio.Group onChange={onTestChange}>
						<Radio.Button value={'rbc'}>RBC</Radio.Button>
						<Radio.Button value={'wbc'}>WBC</Radio.Button>
					</Radio.Group>
				</Col>
				<Col span={18}>
					<div className="chart-container">
						<LineChart dataset={dataset} />
					</div>
				</Col>
				<Button onClick={handleShowModal}>Modal</Button>
				<Button onClick={handleCloseModal}>Close modal</Button>
				<Modal title={'this is a test'} visible={showModal} onOk={handleCloseModal} mask={false}>
					This is a test
				</Modal>
			</Row>
		</div>
	);
}

export default Boilerplate;
